import axios from 'axios';

import { TravelLineResponse } from '../../components/admin-portal/Tables/TravelCosts/Arrangements/hooks/TravelLines/types';
import { Arrangement } from '../../components/admin-portal/Tables/TravelCosts/Arrangements/types';

import { ARRANGEMENTS, TRAVEL_LINES } from '../endpoints';

export const getArrangements = () =>
  axios.get<Arrangement[]>(`${ARRANGEMENTS}`);

export const getArrangement = (id: number) =>
  axios.get<Arrangement>(`${ARRANGEMENTS}/${id}`);

export const createArrangement = (data: Arrangement) =>
  axios.post<Arrangement>(`${ARRANGEMENTS}`, data);

export const editArrangement = (data: Arrangement) =>
  axios.put<Arrangement>(`${ARRANGEMENTS}/${data.trvSetId}`, data);

export const deleteArrangement = (id: number) =>
  axios.delete(`${ARRANGEMENTS}/${id}`);

export const getTravelLines = (id: number) =>
  axios.get<TravelLineResponse[]>(`${TRAVEL_LINES}?trvSetId=${id}`);
